import { Components } from "@thisgorilla/primate-ds";
import { useMemo } from "react";
import styled, { useTheme } from "styled-components";
import { useAppSelector } from "../../../../../../redux";
import {
  addProxyUrlToProfileImage,
  getPeopleNamesText,
} from "../../../../../../utils";
import { FlexRow } from "../../../../../Common/Styles";

export const AvatarGroupAndDescription = () => {
  const { typography } = useTheme();
  const { peopleYouMightKnow } = useAppSelector((state) => state.me);

  //#region Data
  const AvatarGroupSrc = useMemo(() => {
    if (!peopleYouMightKnow || !peopleYouMightKnow.length) return [];

    const AvatarGroupSrc = peopleYouMightKnow.map((people) =>
      addProxyUrlToProfileImage(people.profile_picture)
    );

    return AvatarGroupSrc;
  }, [peopleYouMightKnow]);

  const peopleYouMightKnowText = useMemo(
    () => getPeopleNamesText(peopleYouMightKnow),
    [peopleYouMightKnow]
  );
  //#endregion

  return (
    <Container $gapInPx={10}>
      {AvatarGroupSrc.length > 0 && (
        <Components.AvatarGroup
          size="XSmall-28"
          src={AvatarGroupSrc}
          srcCountToBeRendered={3}
        />
      )}
      <Components.Text
        text={peopleYouMightKnowText}
        style={{ tokenStyle: typography.Body.S }}
        maxLineLength={2}
      />
    </Container>
  );
};

const Container = styled(FlexRow)`
  align-items: center;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-05"].value}rem
    ${({ theme }) => theme.spacing["spacing-1"].value}rem;
`;
